import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import ClickMarker from '../../../components/Map/ClickMarker';
import { SunEdit } from '../../../components/SunEdit/SunEdit';
import UploadImg from '../../../components/Upload/UploadImg';
import Text from 'antd/es/typography/Text';
import { SaveOutlined } from '@ant-design/icons';
import { useService } from './ServiceStore';
import { useForm } from 'antd/es/form/Form';
import { useEffect } from 'react';

function Edit({ service }) {

    let {
        start,
        handleChangeRegion,
        regions,
        st,
        sdistricts,
        file,
        setFile,
        latlong,
        setLatlong,
        setDsc,
        handleRemoveImage,
        handleSubmit,
        submitting,
        districts
    } = useService()

    let [form] = useForm()

    useEffect(() => {
        if (service) {
            form.setFieldsValue({
                vendor_types_id: service.vendor_types_id,
                name: service.name,
                description: service.description,
                price: service.price,
                districts_regions_id: service.districts_regions_id,
                districts_id: service.districts_id,
                address: service.address,
                phone: service.phone,
                whatsapp: service.whatsapp,
                telegram: service.telegram,
                instagram: service.instagram,
                tiktok: service.tiktok,
                youtube: service.youtube,
                website: service.website,
                email: service.email,
                lat: service.lat,
                long: service.long,
            })
        }

        setLatlong({ lat: service.lat, lng: service.long })

    }, [service, setLatlong])

    useEffect(() => {
        start()
    }, [form, setLatlong]);

    return (
        <Form layout="vertical" onFinish={(values) => handleSubmit(values, form)} requiredMark={false} form={form}>

            {/* === Xizmat turi va nomi === */}
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item rules={[{ required: true, message: 'Xizmat turini tanlang' }]} label="Xizmat turi" name="vendor_types_id">
                        <Select
                            getPopupContainer={t => t.parentNode}
                            placeholder="Tanlang..."
                            size="large"
                            showSearch
                            options={st.map(s => ({ label: s.name, value: s.id }))}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item rules={[{ required: true, message: 'Xizmat nomini kiriting' }]} label="Xizmat nomi" name="name">
                        <Input placeholder="Masalan: To'yxona Navruz" size="large" />
                    </Form.Item>
                </Col>
            </Row>

            {/* === Joylashuv === */}
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item rules={[{ required: true, message: 'Viloyatni tanlang' }]} label="Viloyat" name="districts_regions_id">
                        <Select
                            getPopupContainer={t => t.parentNode}
                            placeholder="Viloyat"
                            size="large"
                            showSearch
                            optionFilterProp="label"
                            options={regions.map(r => ({ label: r.nameUz, value: r.id }))}
                            onChange={handleChangeRegion}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item rules={[{ required: true, message: 'Tumanni tanlang' }]} label="Tuman" name="districts_id">
                        <Select
                            getPopupContainer={t => t.parentNode}
                            placeholder={sdistricts.length ? "Tuman" : "Avval viloyat tanlang"}
                            size="large"
                            showSearch
                            optionFilterProp="label"
                            disabled={!sdistricts.length}
                            options={sdistricts.length ? sdistricts.map(d => ({ label: d.nameUz, value: d.id })) : districts.map(d => ({ label: d.nameUz, value: d.id }))}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item rules={[{ required: true, message: 'Manzilni kiriting' }]} label="Manzil" name="address">
                        <Input placeholder="Ko'cha, uy raqami" size="large" />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid var(--qk-border)', marginTop: 4 }}>
                <ClickMarker position={latlong} setPosition={setLatlong} height="280px" />
            </div>

            {/* === Tavsif === */}
            <Form.Item label="Batafsil ma'lumot">
                <SunEdit setter={setDsc} height="200px" content={service?.desc} />
            </Form.Item>

            {/* === Rasmlar === */}
            <Space wrap size={12} style={{ marginBottom: 8 }}>
                <UploadImg setImgurl={setFile} images={service?.images.file_path} />
                {
                    !file.length && (
                        <Text type="secondary" style={{ fontSize: 12 }}>Hali rasm yuklanmagan</Text>
                    )
                }
            </Space>

            {/* === Submit === */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: 8 }}>
                <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    loading={submitting}
                    icon={<SaveOutlined />}
                    style={{
                        borderRadius: 12,
                        height: 46,
                        paddingInline: 28,
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        boxShadow: '0 4px 14px rgba(102,126,234,0.4)',
                    }}
                >
                    Saqlash va keyingi qadam
                </Button>
            </div>
        </Form >
    );
}

export default Edit;